import React from "react";
import ProfileLayout from "../../components/layout/ProfileLayout";
import ProfileSectionHome from "./components/ProfileSectionHome";

const ProfileSection = () => {
  return (
    <ProfileLayout>
      <ProfileSectionHome />
    </ProfileLayout>
  );
};

export default ProfileSection;
